import 'whatwg-fetch';
import * as Browser from './Browser';

const defaultSetting = {
    method: 'GET',
    body: undefined,
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    }
};

function drawSnippets(snippets) {
    Object.keys(snippets).map(function(snippetId) {
        let snippet = document.getElementById(snippetId);
        snippet.innerHTML = snippets[snippetId];
        loadsripts(snippet);
    });
}

function loadsripts(snippet) {
    let scripts = snippet.querySelectorAll('script');
    scripts.forEach(function(script) {
        let scriptEl = document.createElement('script');
        scriptEl.innerHTML = script.innerHTML;

        if (script.hasAttributes()) {
            const attrs = script.attributes;
            for (let j = 0; j < attrs.length; j++) {
                const attrName = attrs[j].name;
                scriptEl[attrName] = attrs[j].value;
            }
        }

        document.head.appendChild(scriptEl);
        script.parentElement.removeChild(script);
    });
}

function processSnippets(response) {
    if(response.hasOwnProperty('snippets')) {
        drawSnippets(response.snippets);
    }

    return response;
}

function processUrlChange(response)  {
    if(response.hasOwnProperty('newUrl')) {
        Browser.changeUrl(response.newUrl);
    }

    return response;
}

function processRedirection(response) {
    if(response.hasOwnProperty('redirect')) {
        Browser.redirect(response.redirect);
    }

    return response;
}

function prepareFetchSettings(settings) {
    return {
        credentials: 'include',
        method: settings.method.toUpperCase(),
        body: settings.body,
        headers: new Headers(settings.headers),
    }
}

export function sendRequest(requestSettings = {})
{
    const settings = Object.assign({}, defaultSetting, requestSettings);

    return fetch(
        requestSettings.url, prepareFetchSettings(settings)
    ).then(response => { // vytahne z odezvy JSON a preda dal
        return response.json();
    }).then(response => {// Ověříme jestli response vratila snippety a připadně je překreslíme
        return processSnippets(response);
    }).then(response => {// Ověříme jestli response neposlala pokyn k aktualizaci adresy browseru
        return processUrlChange(response);
    }).then(response => { // Ověříme jestli nepřišel pokyn k přesměrování
        return processRedirection(response);
    }).then(response => {
        return Object.assign({}, requestSettings, {response: response});
    }).catch(function(error) {
        console.log(error);
    });
}
